export function WifiSlashIcon(props) {
    return (
        <>
            <svg width={props.width ?? 16} height={props.height ?? 16} viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                <rect fill="none" height="256" width="256" />
                <line fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" x1="48" x2="208" y1="40" y2="216" />
                <path
                    d="M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2"
                    fill="none"
                    stroke="#000"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="16"
                />
                <path d="M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                <path d="M152.1,107A97.5,97.5,0,0,1,197,132.1" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                <path d="M59,132.1A98.7,98.7,0,0,1,108,106" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                <path d="M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                <circle cx="128" cy="200" r="12" />
            </svg>
        </>
    );
}
